import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { GetSalaryStructureGraphQLRequest, GetSalaryStructureGraphQLResponse } from '../types';

export const getSalaryStructureQuery = gql`
  query PayrollGetSalaryStructure($input: PayrollGetSalaryStructureInput!) {
    payrollGetSalaryStructure(input: $input) {
      data {
        id
        name
        description
        status
        employeeCount
        type
        salaryStructureComponents {
          id
          formula
          valueType
          salaryComponentId
          salaryComponent {
            id
            name
            description
            defaultFormula
            category
            settings {
              behaviour {
                pfBehaviour {
                  includeInPfWages
                }
                ptBehaviour {
                  includeInPtWages
                }
                esiBehaviour {
                  includeInEsiWages
                }
                lwfBehaviour {
                  includeInLwfWages
                }
                taxBehaviour {
                  taxExemptionSection
                  taxDeductionBehaviour
                  taxExemptInNewRegime
                  taxExemptInOldRegime
                }
                arrearBehaviour {
                  considerInArrear
                }
                prorationBehaviour {
                  supportProration
                }
                displayBehaviour {
                  showZero
                  visibleToEmployee
                  displayName
                }
              }
              earningDetails {
                payType
              }
              deductionDetails {
                deductionType
                deductFrom
              }
              bonusDetails {
                clawbackDuration
                isTaxable
              }
              perquisiteDetails {
                isTaxable
              }
              nonPayableBenefitsDetails {
                isPartOfCTC
                visibilityToEmployee
              }
            }
            isPredefined
            isActive
            source
            componentType
          }
        }
      }
      code
      success
      message
    }
  }
`;

export const getSalaryStructure = (queryVariables: GetSalaryStructureGraphQLRequest) => {
  return graphQLApi<GetSalaryStructureGraphQLResponse, GetSalaryStructureGraphQLRequest>({
    query: getSalaryStructureQuery,
    queryVariables,
  });
};

export default getSalaryStructure;
